// Education level constants
export const EDUCATION_LEVELS = {
  PRE_SCHOOL: 'pre_school',
  KINDERGARTEN: 'kindergarten',
  NURSERY: 'nursery',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  /*PRE_DEGREE: 'pre_degree',
  UABS: 'uabs',
  OND: 'ond',
  HND: 'hnd',
  NCE: 'nce',
  UNDERGRADUATE: 'undergraduate',
  POSTGRADUATE: 'postgraduate',
  MASTERS: 'masters',
  PHD: 'phd',
  OTHERS: 'others'*/
};

// Education level display names
export const EDUCATION_LEVEL_LABELS = {
  [EDUCATION_LEVELS.PRE_SCHOOL]: 'Pre-School',
  [EDUCATION_LEVELS.KINDERGARTEN]: 'Kindergarten',
  [EDUCATION_LEVELS.NURSERY]: 'Nursery',
  [EDUCATION_LEVELS.PRIMARY]: 'Primary',
  [EDUCATION_LEVELS.SECONDARY]: 'Secondary',
  /*[EDUCATION_LEVELS.PRE_DEGREE]: 'Pre-Degree',
  [EDUCATION_LEVELS.UABS]: 'UABS',
  [EDUCATION_LEVELS.OND]: 'OND',
  [EDUCATION_LEVELS.HND]: 'HND',
  [EDUCATION_LEVELS.NCE]: 'NCE',
  [EDUCATION_LEVELS.UNDERGRADUATE]: 'Undergraduate',
  [EDUCATION_LEVELS.POSTGRADUATE]: 'Postgraduate',
  [EDUCATION_LEVELS.MASTERS]: 'Masters',
  [EDUCATION_LEVELS.PHD]: 'PhD',
  [EDUCATION_LEVELS.OTHERS]: 'Others'*/
};

// Get education level options for select dropdowns
export const getEducationLevelOptions = () => {
  return Object.entries(EDUCATION_LEVEL_LABELS).map(([value, label]) => ({
    value,
    label
  }));
};

// Get education level label by value
export const getEducationLevelLabel = (value) => {
  return EDUCATION_LEVEL_LABELS[value] || value;
};

export const getFundEducationLevels = fund => (
  Array.isArray(fund?.educational_levels)
    ? fund.educational_levels
    : (fund?.educational_level ? [fund.educational_level] : [])
);

// Validate education level
export const isValidEducationLevel = (level) => {
  return Object.values(EDUCATION_LEVELS).includes(level);
};

// Generate enrollment form URL for parent-facing form
export const generateEnrollmentFormUrl = (schoolSlug, levelOfEducation) => {
  return `/${schoolSlug}/admission/${levelOfEducation}`;
};

// Default sections for each education level
export const getDefaultSectionsForLevel = (levelOfEducation) => {
  const baseSections = [
    {
      title: "Child's Bio Data",
      description: "Details about the child's identity and background.",
      order: 1,
      is_active: true,
      fields: [
        {
          name: "child_passport",
          label: "Child's Passport Photograph",
          type: "file",
          required: false,
          placeholder: "Enter passport photograph",
          order: 1,
          is_active: true
        },
        {
          name: "child_first_name",
          label: "Child's First Name",
          type: "text",
          required: true,
          placeholder: "Enter first name",
          order: 2,
          is_active: true
        },
        {
          name: "child_last_name",
          label: "Child's Last Name",
          type: "text",
          required: true,
          placeholder: "Enter last name",
          order: 3,
          is_active: true
        },
        {
          name: "child_middle_name",
          label: "Child's Middle Name",
          type: "text",
          required: false,
          placeholder: "Enter middle name",
          order: 4,
          is_active: true
        },
        {
          name: "dob",
          label: "Date of Birth",
          type: "date",
          required: true,
          order: 5,
          is_active: true
        },
        {
          name: "gender",
          label: "Gender",
          type: "select",
          required: true,
          options: ["Male", "Female"],
          order: 6,
          is_active: true
        },
        {
          name: "nationality",
          label: "Nationality",
          type: "text",
          required: true,
          order: 7,
          is_active: true
        },
        {
          name: "religion",
          label: "Religion",
          type: "text",
          required: true,
          order: 8,
          is_active: true
        },
        {
          name: "class",
          label: "Class",
          type: "text",
          required: true,
          order: 9,
          is_active: true
        },
        {
          name: "previous_school",
          label: "Previous School Attended",
          type: "text",
          required: false,
          order: 10,
          is_active: true
        }
      ]
    },
    {
      title: "Parent/Guardian Information",
      description: "Information about the child's parents or guardians.",
      order: 2,
      is_active: true,
      fields: [
        {
          name: "parent1_first_name",
          label: "Parent/Guardian 1 First Name",
          type: "text",
          required: true,
          order: 1,
          is_active: true
        },
        {
          name: "parent1_last_name",
          label: "Parent/Guardian 1 Last Name",
          type: "text",
          required: true,
          order: 2,
          is_active: true
        },
        {
          name: "parent1_relationship",
          label: "Relationship to Child",
          type: "text",
          required: true,
          order: 3,
          is_active: true
        },
        {
          name: "parent1_occupation",
          label: "Occupation",
          type: "text",
          required: true,
          order: 4,
          is_active: true
        },
        {
          name: "parent1_contact",
          label: "Contact Number",
          type: "phone",
          required: true,
          order: 5,
          is_active: true
        },
        {
          name: "parent1_email",
          label: "Email",
          type: "email",
          required: false,
          order: 6,
          is_active: true
        },
        {
          name: "parent1_address_line",
          label: "Address Line 1",
          type: "text",
          required: true,
          order: 7,
          is_active: true
        },
        {
          name: "parent1_city",
          label: "City",
          type: "text",
          required: true,
          order: 8,
          is_active: true
        },
        {
          name: "parent1_state",
          label: "State",
          type: "text",
          required: true,
          order: 9,
          is_active: true
        }
      ]
    },
    {
      title: "Parent/Guardian 2 Information",
      description: "Information about the child's second parent or guardian.",
      order: 3,
      is_active: true,
      fields: [
        {
          name: "parent2_first_name",
          label: "Parent/Guardian 2 First Name",
          type: "text",
          required: true,
          order: 1,
          is_active: true
        },
        {
          name: "parent2_last_name",
          label: "Parent/Guardian 2 Last Name",
          type: "text",
          required: true,
          order: 2,
          is_active: true
        },
        {
          name: "parent2_relationship",
          label: "Relationship to Child",
          type: "text",
          required: true,
          order: 3,
          is_active: true
        },
        {
          name: "parent2_occupation",
          label: "Occupation",
          type: "text",
          required: true,
          order: 4,
          is_active: true
        },
        {
          name: "parent2_contact",
          label: "Contact Number",
          type: "phone",
          required: true,
          order: 5,
          is_active: true
        },
        {
          name: "parent2_email",
          label: "Email",
          type: "email",
          required: false,
          order: 6,
          is_active: true
        },
        {
          name: "parent2_address_line",
          label: "Address Line 1",
          type: "text",
          required: true,
          order: 7,
          is_active: true
        },
        {
          name: "parent2_city",
          label: "City",
          type: "text",
          required: true,
          order: 8,
          is_active: true
        },
        {
          name: "parent2_state",
          label: "State",
          type: "text",
          required: true,
          order: 9,
          is_active: true
        }
      ]
    },
    {
      title: "Declaration",
      description: "We, the undersigned, declare that the information provided is accurate and true. We understand that any false information may lead to the cancellation of admission.",
      order: 4,
      is_active: true,
      fields: [
        {
          name: "consent",
          label: "consent",
          type: "radio",
          required: true,
          placeholder: "I agree to the terms and conditions",
          order: 1,
          is_active: true
        }
      ]
    }
  ];

  // Add level-specific sections
  if (levelOfEducation === EDUCATION_LEVELS.PRIMARY || levelOfEducation === EDUCATION_LEVELS.SECONDARY) {
    baseSections.splice(3, 0, {
      title: "Academic Information",
      description: "Academic background and additional information.",
      order: 4,
      is_active: true,
      fields: [
        {
          name: "previous_class",
          label: "Class in Previous School",
          type: "text",
          required: false,
          order: 1,
          is_active: true
        },
        {
          name: "medical_conditions",
          label: "Any Medical Conditions",
          type: "textarea",
          required: false,
          order: 2,
          is_active: true
        },
        {
          name: "emergency_contact_person",
          label: "Emergency Contact Person",
          type: "text",
          required: false,
          order: 3,
          is_active: true
        },
        {
          name: "special_needs",
          label: "Special Needs or Requirements",
          type: "textarea",
          required: false,
          order: 4,
          is_active: true
        }
      ]
    });
  }

  // Update order for declaration section
  baseSections[baseSections.length - 1].order = baseSections.length;

  return baseSections;
};
